import { useSelector } from 'react-redux';
import { ButtonRoot, ButtonTitle } from './styles';

import { useState } from 'react';
import { getMode } from '@store/slices/configSlice';
import { MODE } from '@utils/constants';

interface ButtonProps {
  icon?: React.ReactNode;
  title: string;
  backgroundColor?: string;
  textColor?: string;
  onClick?: () => void;
  borderRadius?: string;
  padding?: string;
  border?: string;
  width?: string;
  hoverBackgroundColor?: string;
  fontSize?: string;
  hoverTextColor?: string;
  lineHeight?: string;
  fontWeight?: string;
  disabled?: boolean;
  testId?: string;
  type?: 'button' | 'reset' | 'submit' | undefined;
  margin?: string;
}

const RegularButton = ({
  icon,
  title,
  onClick,
  border,
  backgroundColor = 'grey',
  textColor,
  borderRadius,
  padding,
  width,
  hoverBackgroundColor,
  fontSize,
  hoverTextColor,
  lineHeight,
  fontWeight,
  disabled = false,
  testId = 'regular-button',
  type = 'button',
  margin,
}: ButtonProps) => {
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const mode = useSelector(getMode);
  return (
    <ButtonRoot
      type={type ?? 'button'}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      $borderRadius={borderRadius}
      $padding={padding}
      $border={border}
      $backgroundColor={backgroundColor}
      $width={width}
      $hoverBackgroundColor={hoverBackgroundColor}
      $disabled={disabled}
      $margin={margin}
      data-testid={testId}
      onMouseOver={() => {
        if (!disabled) {
          setIsHovered(true);
        }
      }}
      onMouseOut={() => {
        setIsHovered(false);
      }}
    >
      <ButtonTitle
        $textColor={textColor}
        $hoverTextColor={hoverTextColor}
        $fontFamily={
          mode === MODE.EVENT ||
          mode === MODE.PORTFOLIO ||
          mode === MODE.WEBINAR
            ? 'Lato, Arial, sans-serif'
            : 'proxima-nova, sans-serif'
        }
        $fontSize={fontSize}
        $isHovered={isHovered}
        $lineHeight={lineHeight}
        $fontWeight={fontWeight}
      >
        {icon || null}
        {title}
      </ButtonTitle>
    </ButtonRoot>
  );
};

export default RegularButton;
